import { FunctionComponent } from 'react';

// Libs
import classnames from 'classnames';

// Contexts
import { ViewMedia, useViewDetected } from '@Components/Utils/ViewDetected';

// Components
import Image from '@Components/Utils/Image';
import Form from '@Pages/cong-tac-vien/Components/Form';

// Styles
import styles from './Registration.module.scss';

interface RegistrationProps {
    className?: string;
}

const STEPS = [
    {
        image: '/assets/cong-tac-vien/step_1.png',
        content: (
            <>
                <b>Bước 1</b>
                <br />
                Đăng ký thông tin vào mẫu kế bên để nộp hồ sơ
            </>
        ),
    },
    {
        image: '/assets/cong-tac-vien/step_2.png',
        content: (
            <>
                <b>Bước 2</b>
                <br />
                Tham gia đào tạo dịch vụ
            </>
        ),
    },
    {
        image: '/assets/cong-tac-vien/step_3.png',
        content: (
            <>
                <b>Bước 3</b>
                <br />
                Bắt đầu công việc lấy mẫu
            </>
        ),
    },
];

const Registration: FunctionComponent<RegistrationProps> = ({ className }) => {
    const { deviceType } = useViewDetected();

    const isMobile = deviceType !== 'desktop';

    const renderStepItem = () => {
        return STEPS.map((step, index) => (
            <div key={`step-item-${index}`} className={styles.step}>
                <Image src={step.image} width={80} height={80} className={styles.step_img} />

                <div className={styles.step_content}>{step.content}</div>
            </div>
        ));
    };

    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.mobile]: isMobile,
        },
        className,
    ]);

    return (
        <div className={wrapperClassName}>
            <div className={styles.step_wrapper}>
                <div className={styles.title}>
                    Tham gia
                    <br />
                    <span className={classnames(['text-primary', styles.edoctor])}>eDoctor!</span>
                    <br />
                    chỉ với 3 bước đơn giản
                </div>

                {renderStepItem()}

                <ViewMedia is="desktop">
                    <Image
                        width={568}
                        height={344}
                        className={styles.bg_desktop}
                        src="/assets/cong-tac-vien/bg_desktop.png"
                    />
                </ViewMedia>

                <ViewMedia is={['mobile', 'tablet']}>
                    <Image
                        width={188}
                        height={148}
                        className={styles.bg_mobile}
                        src="/assets/cong-tac-vien/bg_mobile.png"
                    />
                </ViewMedia>
            </div>
            <div className={styles.form}>
                <Form />
            </div>
        </div>
    );
};

Registration.defaultProps = {
    className: '',
};

export default Registration;
